export const DBN_CATEGORY_ACCOUNT_MAPPINGS_RESET_STATE = 'DBN_CATEGORY_ACCOUNT_MAPPINGS_RESET_STATE';
export const DBN_CATEGORY_ACCOUNT_MAPPINGS_CURRENT_ITEM = 'DBN_CATEGORY_ACCOUNT_MAPPINGS_CURRENT_ITEM';

export const DBN_CATEGORY_ACCOUNT_MAPPINGS_REQUEST_LOADING = 'DBN_CATEGORY_ACCOUNT_MAPPINGS_REQUEST_LOADING';
export const DBN_CATEGORY_ACCOUNT_MAPPINGS_REQUEST_SUCCESS = 'DBN_CATEGORY_ACCOUNT_MAPPINGS_REQUEST_SUCCESS';
export const DBN_CATEGORY_ACCOUNT_MAPPINGS_REQUEST_FAILED = 'DBN_CATEGORY_ACCOUNT_MAPPINGS_REQUEST_FAILED';

export const DBN_CATEGORY_ACCOUNT_MAPPINGS_CURRENT_ACTION = 'DBN_CATEGORY_ACCOUNT_MAPPINGS_CURRENT_ACTION';
export const DBN_CATEGORY_ACCOUNT_MAPPINGS_RESET_ACTION = 'DBN_CATEGORY_ACCOUNT_MAPPINGS_RESET_ACTION';